import React from 'react';
import { ExternalLink } from '@yme/assets/icons';
import { ButtonLinkWrapperComponent } from '@yme/molecules/buttons/button-link-wrapper/ButtonLinkWrapper';
import { noop } from '@yme/utils/common';
import { NavItem, NavItemLink } from './NavItemStyled';
export function NavLink({ linkTitle, link, isExternalLink, isRightToLeft, onClick, }) {
    return (React.createElement(NavItem, { key: linkTitle, onClick: onClick ?? noop },
        React.createElement(ButtonLinkWrapperComponent, { buttonLink: link },
            React.createElement(NavItemLink, { isRightToLeft: isRightToLeft, isExternalLink: isExternalLink, iconUrl: ExternalLink }, linkTitle))));
}
